import { useState } from "react";
import { useLocalStorage } from "@mantine/hooks";
import { OnChangeFn } from "@tanstack/react-table";
import { MRT_PaginationState } from "mantine-react-table";

const DEFAULT_PAGE_SIZE = 30;

export const usePaginationSearchParamsState = () => {
  const [pageIndex, setPageIndex] = useState(0);

  const [pageSize, setStoredPageSize] = useLocalStorage({
    key: "table:default-page-size",
    defaultValue: DEFAULT_PAGE_SIZE,
  });

  const setPagination: NonNullable<OnChangeFn<MRT_PaginationState>> = (
    updaterOrValue,
  ) => {
    const resolvedPagination =
      typeof updaterOrValue === "function"
        ? updaterOrValue({
            pageIndex,
            pageSize,
          })
        : updaterOrValue;

    setPageIndex(resolvedPagination.pageIndex);
    setStoredPageSize(resolvedPagination.pageSize);
  };

  const pagination = {
    pageIndex,
    pageSize,
  };

  return [pagination, setPagination] as const;
};
